// extracted by mini-css-extract-plugin
export default {"cityChooser":"c-j_cR","cityChooser__text":"c-j_cS","cityChooser__placeholder":"c-j_cT","cityChooser__buttonIcon":"c-j_cU"};